// ============================================================
// ADMINISTRACIÓN DE CASA
// ============================================================

import {
  mostrarToast,
  obtenerUrlBackend
} from './utilerias.js';


const URL_BASE_API =
  obtenerUrlBackend('8083');

const API_BASE_URL =
  `${URL_BASE_API}/api/mntoCasa`;

const TOKEN_KEY =
  'token_teresita';


let tablaElementos = null;
let tablaCategorias = null;

let elementoActual = null;
let categoriaActual = null;

let elementoAEliminar = null;
let categoriaAEliminar = null;

let opcionesInternas = [];
let categoriasCasa = [];


// ============================================================
// TEMPLATE
// ============================================================

const templateCasaAdmin = `

<div class="mnto-casa-container">

  <div class="mnto-casa-tabs">

    <button
      type="button"
      class="mnto-casa-tab active"
      data-tab="elementos"
      id="tabElementos"
    >
      <i class="fas fa-home"></i>
      Elementos
    </button>

    <button
      type="button"
      class="mnto-casa-tab"
      data-tab="categorias"
      id="tabCategorias"
    >
      <i class="fas fa-folder"></i>
      Categorías
    </button>

  </div>


  <!-- =====================================================
       ELEMENTOS
  ====================================================== -->

  <section
    id="panelElementos"
    class="mnto-casa-panel active"
  >

    <div class="mnto-casa-toolbar">

      <button
        type="button"
        id="btnAgregarElementoCasa"
        class="btn btn-primary btn-icon"
      >
        <i class="fas fa-plus"></i>
        Nuevo elemento
      </button>

    </div>


    <div class="card">

      <div class="table-responsive">

        <table
          id="tablaCasaElementos"
          class="table table-striped"
          style="width:100%"
        >

          <thead>

            <tr>

              <th>Nombre</th>

              <th>Posición</th>

              <th>Tipo</th>

              <th>Destino</th>

              <th>Orden</th>

              <th>Color</th>

              <th>Activo</th>

              <th class="text-center">
                Acciones
              </th>

            </tr>

          </thead>

          <tbody></tbody>

        </table>

      </div>

    </div>

  </section>


  <!-- =====================================================
       CATEGORÍAS
  ====================================================== -->

  <section
    id="panelCategorias"
    class="mnto-casa-panel"
  >

    <div class="mnto-casa-toolbar">

      <button
        type="button"
        id="btnAgregarCategoriaCasa"
        class="btn btn-primary btn-icon"
      >
        <i class="fas fa-plus"></i>
        Nueva categoría
      </button>

    </div>


    <div class="card">

      <div class="table-responsive">

        <table
          id="tablaCasaCategorias"
          class="table table-striped"
          style="width:100%"
        >

          <thead>

            <tr>

              <th>ID</th>

              <th>Nombre</th>

              <th>Orden</th>

              <th>Activo</th>

              <th class="text-center">
                Acciones
              </th>

            </tr>

          </thead>

          <tbody></tbody>

        </table>

      </div>

    </div>

  </section>

</div>


<!-- =========================================================
     MODAL ELEMENTO
========================================================= -->

<div
  id="modalCasaElemento"
  class="modal-overlay"
>

  <div class="modal-container modal-lg">

    <div class="modal-header">

      <h4 id="modalElementoTitulo">
        Nuevo elemento
      </h4>

      <button
        type="button"
        class="modal-close"
        id="btnCerrarElemento"
      >
        &times;
      </button>

    </div>


    <div class="modal-body">

      <form id="formCasaElemento">

        <input
          type="hidden"
          id="casa_id_elemento"
        >


        <div class="form-group">

          <label for="casa_nombre">
            Nombre *
          </label>

          <input
            type="text"
            id="casa_nombre"
            class="form-control"
            maxlength="100"
            required
          >

        </div>


        <div class="form-row">

          <div class="form-group">

            <label for="casa_posicion">
              Posición *
            </label>

            <select
              id="casa_posicion"
              class="form-control"
              required
            >

              <option value="techo">
                Techo
              </option>

              <option value="pared">
                Pared
              </option>

            </select>

          </div>


          <div class="form-group">

            <label for="casa_orden">
              Orden
            </label>

            <input
              type="number"
              id="casa_orden"
              class="form-control"
              min="0"
              value="0"
            >

          </div>

        </div>


        <div class="form-group">

          <label for="casa_tipo_destino">
            Tipo de destino *
          </label>

          <select
            id="casa_tipo_destino"
            class="form-control"
            required
          >

            <option value="interno">
              Aplicación interna
            </option>

            <option value="externo">
              URL externa
            </option>

            <option value="categoria">
              Categoría
            </option>

          </select>

        </div>


        <!-- INTERNO -->

        <div
          id="grupoDestinoInterno"
          class="form-group casa-destino-grupo"
        >

          <label for="casa_id_opcion">
            Aplicación interna *
          </label>

          <select
            id="casa_id_opcion"
            class="form-control"
          >

            <option value="">
              Seleccione una aplicación
            </option>

          </select>

        </div>


        <!-- EXTERNO -->

        <div
          id="grupoDestinoExterno"
          class="casa-destino-grupo"
          style="display:none;"
        >

          <div class="form-group">

            <label for="casa_url_externa">
              URL externa *
            </label>

            <input
              type="url"
              id="casa_url_externa"
              class="form-control"
              placeholder="https://..."
            >

          </div>


          <div class="form-group">

            <label class="checkbox-label">

              <input
                type="checkbox"
                id="casa_nueva_ventana"
              >

              Abrir en nueva ventana

            </label>

          </div>

        </div>


        <!-- CATEGORÍA -->

        <div
          id="grupoDestinoCategoria"
          class="form-group casa-destino-grupo"
          style="display:none;"
        >

          <label for="casa_id_categoria">
            Categoría *
          </label>

          <select
            id="casa_id_categoria"
            class="form-control"
          >

            <option value="">
              Seleccione una categoría
            </option>

          </select>

        </div>


        <!-- COLOR -->

        <div class="form-group">

          <label>
            Color
          </label>

          <div class="casa-color-control">

            <input
              type="color"
              id="casa_color_picker"
              value="#d9e8f7"
            >

            <input
              type="text"
              id="casa_color"
              class="form-control"
              value="#d9e8f7"
              maxlength="7"
              placeholder="#D9E8F7"
            >

            <div
              id="casa_color_preview"
              class="casa-color-preview"
            ></div>

          </div>

        </div>


        <div class="form-group">

          <label for="casa_icono">
            Icono
          </label>

          <input
            type="text"
            id="casa_icono"
            class="form-control"
            maxlength="50"
            placeholder="Ej: fa-chart-line"
          >

        </div>


        <div class="form-group">

          <label for="casa_activo">
            Activo
          </label>

          <select
            id="casa_activo"
            class="form-control"
          >

            <option value="true">
              Sí
            </option>

            <option value="false">
              No
            </option>

          </select>

        </div>

      </form>

    </div>


    <div class="modal-footer">

      <button
        type="button"
        class="btn btn-secondary"
        id="btnCancelarElemento"
      >
        Cancelar
      </button>

      <button
        type="submit"
        class="btn btn-primary"
        form="formCasaElemento"
      >
        <i class="fas fa-save"></i>
        Guardar
      </button>

    </div>

  </div>

</div>


<!-- =========================================================
     MODAL CATEGORÍA
========================================================= -->

<div
  id="modalCasaCategoria"
  class="modal-overlay"
>

  <div class="modal-container">

    <div class="modal-header">

      <h4 id="modalCategoriaTitulo">
        Nueva categoría
      </h4>

      <button
        type="button"
        class="modal-close"
        id="btnCerrarCategoria"
      >
        &times;
      </button>

    </div>


    <div class="modal-body">

      <form id="formCasaCategoria">

        <input
          type="hidden"
          id="categoria_id"
        >


        <div class="form-group">

          <label for="categoria_nombre">
            Nombre *
          </label>

          <input
            type="text"
            id="categoria_nombre"
            class="form-control"
            maxlength="100"
            required
          >

        </div>


        <div class="form-group">

          <label for="categoria_orden">
            Orden
          </label>

          <input
            type="number"
            id="categoria_orden"
            class="form-control"
            min="0"
            value="0"
          >

        </div>


        <div class="form-group">

          <label for="categoria_activo">
            Activa
          </label>

          <select
            id="categoria_activo"
            class="form-control"
          >

            <option value="true">
              Sí
            </option>

            <option value="false">
              No
            </option>

          </select>

        </div>

      </form>

    </div>


    <div class="modal-footer">

      <button
        type="button"
        class="btn btn-secondary"
        id="btnCancelarCategoria"
      >
        Cancelar
      </button>

      <button
        type="submit"
        class="btn btn-primary"
        form="formCasaCategoria"
      >
        <i class="fas fa-save"></i>
        Guardar
      </button>

    </div>

  </div>

</div>


<!-- =========================================================
     CONFIRMAR ELIMINACIÓN
========================================================= -->

<div
  id="modalCasaEliminar"
  class="modal-overlay"
>

  <div class="modal-container modal-sm">

    <div class="modal-header modal-header-danger">

      <h3>
        <i class="fas fa-exclamation-triangle"></i>
        Confirmar eliminación
      </h3>

    </div>


    <div class="modal-body text-center">

      <p id="textoCasaEliminar"></p>

      <p class="text-muted">
        Esta acción no se puede deshacer.
      </p>

    </div>


    <div class="modal-footer justify-center">

      <button
        type="button"
        class="btn btn-secondary"
        id="btnCancelarCasaEliminar"
      >
        Cancelar
      </button>

      <button
        type="button"
        class="btn btn-danger"
        id="btnConfirmarCasaEliminar"
      >
        <i class="fas fa-trash-alt"></i>
        Eliminar
      </button>

    </div>

  </div>

</div>

`;


// ============================================================
// TOKEN
// ============================================================

function getToken() {

  return sessionStorage.getItem(
    TOKEN_KEY
  );

}


// ============================================================
// EXPORT DE LA VISTA
// ============================================================

export function paginaMntoCasa() {

  setTimeout(
    () => inicializarModulo(),
    0
  );

  return templateCasaAdmin;

}


// ============================================================
// INICIALIZACIÓN
// ============================================================

async function inicializarModulo() {

  await Promise.all([
    cargarOpcionesInternas(),
    cargarCategorias()
  ]);

  await cargarElementos();

  bindEvents();

}


// ============================================================
// ELEMENTOS
// ============================================================

async function cargarElementos() {

  try {

    const response = await fetch(
      `${API_BASE_URL}/elementos`,
      {
        headers: {
          'Authorization': getToken(),
          'Content-Type': 'application/json'
        }
      }
    );


    if (!response.ok) {

      throw new Error(
        'Error al cargar elementos'
      );

    }


    const data =
      await response.json();


    inicializarTablaElementos(
      data.elementos || []
    );


  } catch (error) {

    console.error(error);

    mostrarToast(
      'Error al cargar elementos de Casa',
      'error'
    );

  }

}


// ============================================================
// TABLA ELEMENTOS
// ============================================================

function inicializarTablaElementos(datos) {

  const $tabla =
    $('#tablaCasaElementos');


  if (
    $.fn.DataTable.isDataTable($tabla)
  ) {

    $tabla.DataTable().destroy();

  }


  $tabla.find('tbody').empty();


  tablaElementos =
    $tabla.DataTable({

      responsive: true,

      data: datos,

      columns: [

        {
          data: 'nombre'
        },

        {
          data: 'posicion',
          className: 'text-center',
          render: renderPosicion
        },

        {
          data: 'tipo_destino',
          render: renderTipo
        },

        {
          data: null,
          render: renderDestino
        },

        {
          data: 'orden',
          className: 'text-center'
        },

        {
          data: 'color',
          className: 'text-center',
          render: renderColor
        },

        {
          data: 'activo',
          className: 'text-center',
          render: renderActivo
        },

        {
          data: null,
          orderable: false,
          searchable: false,
          className: 'text-center',
          render: renderAccionesElemento
        }

      ],

      order: [
        [1, 'asc'],
        [4, 'asc']
      ],

      pageLength: 10,

      language: idiomaDataTable(),

      dom: 'rtip'

    });

}


// ============================================================
// RENDER TABLA ELEMENTOS
// ============================================================

function renderPosicion(data) {

  if (data === 'techo') {

    return `
      <span class="badge-casa badge-casa--techo">
        Techo
      </span>
    `;

  }

  return `
    <span class="badge-casa badge-casa--pared">
      Pared
    </span>
  `;

}


function renderTipo(data) {

  const nombres = {
    interno: 'Interno',
    externo: 'Externo',
    categoria: 'Categoría'
  };

  return nombres[data] || data;

}


function renderDestino(data) {

  if (
    data.tipo_destino === 'interno'
  ) {

    return data.opcion_nombre ||
           data.opcion_codigo ||
           '—';

  }


  if (
    data.tipo_destino === 'externo'
  ) {

    return `
      <span title="${data.url_externa || ''}">
        ${data.url_externa || '—'}
      </span>
    `;

  }


  if (
    data.tipo_destino === 'categoria'
  ) {

    return data.categoria_nombre ||
           '—';

  }


  return '—';

}


function renderColor(data) {

  if (!data) {

    return '—';

  }


  return `

    <div class="casa-color-cell">

      <span
        class="casa-color-dot"
        style="background:${data}"
      ></span>

      <span>
        ${data}
      </span>

    </div>

  `;

}


function renderActivo(data) {

  const activo =
    data === true ||
    data === 'true' ||
    data === 't' ||
    data === 1 ||
    data === '1';


  return activo
    ? '<span class="estado-activo">Sí</span>'
    : '<span class="estado-inactivo">No</span>';

}


function renderAccionesElemento(data) {

  return `

    <div class="acciones-cell">

      <button
        type="button"
        class="btn-action btn-edit btn-editar-elemento"
        data-id="${data.id_elemento}"
        title="Editar"
      >
        <i class="fas fa-pencil-alt"></i>
      </button>

      <button
        type="button"
        class="btn-action btn-delete btn-eliminar-elemento"
        data-id="${data.id_elemento}"
        data-nombre="${data.nombre}"
        title="Eliminar"
      >
        <i class="fas fa-trash-alt"></i>
      </button>

    </div>

  `;

}


// ============================================================
// ABRIR NUEVO ELEMENTO
// ============================================================

function abrirNuevoElemento() {

  elementoActual = null;

  $('#formCasaElemento')[0].reset();

  $('#casa_id_elemento').val('');

  $('#modalElementoTitulo')
    .text('Nuevo elemento');

  $('#casa_posicion')
    .val('pared');

  $('#casa_tipo_destino')
    .val('interno');

  $('#casa_orden')
    .val(0);

  $('#casa_color')
    .val('#d9e8f7');

  $('#casa_color_picker')
    .val('#d9e8f7');

  $('#casa_activo')
    .val('true');

  $('#casa_nueva_ventana')
    .prop('checked', false);

  actualizarPreviewColor();

  actualizarCamposDestino();

  $('#modalCasaElemento')
    .addClass('active');

  $('#casa_nombre')
    .focus();

}


// ============================================================
// EDITAR ELEMENTO
// ============================================================

async function abrirEditarElemento(id) {

  try {

    const response =
      await fetch(
        `${API_BASE_URL}/elementos/${id}`,
        {
          headers: {
            'Authorization': getToken(),
            'Content-Type': 'application/json'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        'No fue posible obtener el elemento'
      );

    }


    const data =
      await response.json();

    const elemento =
      data.elemento;


    elementoActual =
      elemento.id_elemento;


    $('#casa_id_elemento')
      .val(elemento.id_elemento);

    $('#modalElementoTitulo')
      .text(
        `Editar elemento (ID: ${elemento.id_elemento})`
      );

    $('#casa_nombre')
      .val(elemento.nombre);

    $('#casa_posicion')
      .val(elemento.posicion);

    $('#casa_orden')
      .val(elemento.orden);

    $('#casa_tipo_destino')
      .val(elemento.tipo_destino);

    $('#casa_id_opcion')
      .val(elemento.id_opcion || '');

    $('#casa_url_externa')
      .val(elemento.url_externa || '');

    $('#casa_nueva_ventana')
      .prop(
        'checked',
        elemento.abrir_nueva_ventana === true
      );

    $('#casa_id_categoria')
      .val(elemento.id_categoria || '');

    $('#casa_icono')
      .val(elemento.icono || '');

    const color =
      elemento.color || '#d9e8f7';

    $('#casa_color')
      .val(color);

    $('#casa_color_picker')
      .val(color);

    $('#casa_activo')
      .val(
        elemento.activo === true
          ? 'true'
          : 'false'
      );


    actualizarPreviewColor();

    actualizarCamposDestino();


    $('#modalCasaElemento')
      .addClass('active');


  } catch (error) {

    console.error(error);

    mostrarToast(
      error.message,
      'error'
    );

  }

}


// ============================================================
// GUARDAR ELEMENTO
// ============================================================

async function guardarElemento() {

  const tipo =
    $('#casa_tipo_destino').val();


  const datos = {

    nombre:
      $('#casa_nombre')
        .val()
        .trim(),

    posicion:
      $('#casa_posicion')
        .val(),

    orden:
      parseInt(
        $('#casa_orden').val()
      ) || 0,

    tipo_destino:
      tipo,

    color:
      $('#casa_color')
        .val()
        .trim() || null,

    icono:
      $('#casa_icono')
        .val()
        .trim() || null,

    id_opcion:
      tipo === 'interno'
        ? parseInt(
            $('#casa_id_opcion').val()
          ) || null
        : null,

    url_externa:
      tipo === 'externo'
        ? $('#casa_url_externa')
            .val()
            .trim()
        : null,

    abrir_nueva_ventana:
      tipo === 'externo'
        ? $('#casa_nueva_ventana')
            .is(':checked')
        : false,

    id_categoria:
      tipo === 'categoria'
        ? parseInt(
            $('#casa_id_categoria').val()
          ) || null
        : null,

    activo:
      $('#casa_activo').val() === 'true'

  };


  if (!datos.nombre) {

    mostrarToast(
      'Ingrese el nombre',
      'error'
    );

    return;

  }


  if (
    datos.color &&
    !/^#[0-9A-Fa-f]{6}$/.test(datos.color)
  ) {

    mostrarToast(
      'El color debe tener formato #RRGGBB',
      'error'
    );

    return;

  }


  if (
    tipo === 'interno' &&
    !datos.id_opcion
  ) {

    mostrarToast(
      'Seleccione una aplicación interna',
      'error'
    );

    return;

  }


  if (
    tipo === 'externo' &&
    !datos.url_externa
  ) {

    mostrarToast(
      'Ingrese la URL externa',
      'error'
    );

    return;

  }


  if (
    tipo === 'categoria' &&
    !datos.id_categoria
  ) {

    mostrarToast(
      'Seleccione una categoría',
      'error'
    );

    return;

  }


  const esNuevo =
    !elementoActual;


  const url =
    esNuevo
      ? `${API_BASE_URL}/elementos`
      : `${API_BASE_URL}/elementos/${elementoActual}`;


  try {

    const response =
      await fetch(
        url,
        {
          method:
            esNuevo
              ? 'POST'
              : 'PUT',

          headers: {
            'Authorization': getToken(),
            'Content-Type': 'application/json'
          },

          body:
            JSON.stringify(datos)
        }
      );


    const resultado =
      await response.json();


    if (!response.ok) {

      throw new Error(
        resultado.error ||
        'Error al guardar elemento'
      );

    }


    mostrarToast(
      resultado.mensaje ||
      'Elemento guardado correctamente',
      'success'
    );


    cerrarModalElemento();

    await cargarElementos();


  } catch (error) {

    console.error(error);

    mostrarToast(
      error.message,
      'error'
    );

  }

}


// ============================================================
// ELIMINAR ELEMENTO
// ============================================================

function prepararEliminarElemento(
  id,
  nombre
) {

  elementoAEliminar = id;
  categoriaAEliminar = null;

  $('#textoCasaEliminar')
    .html(
      `¿Desea eliminar el elemento <strong>${nombre}</strong>?`
    );

  $('#modalCasaEliminar')
    .addClass('active');

}


async function eliminarElemento() {

  if (!elementoAEliminar) return;


  try {

    const response =
      await fetch(
        `${API_BASE_URL}/elementos/${elementoAEliminar}`,
        {
          method: 'DELETE',

          headers: {
            'Authorization': getToken(),
            'Content-Type': 'application/json'
          }
        }
      );


    const resultado =
      await response.json();


    if (!response.ok) {

      throw new Error(
        resultado.error ||
        'Error al eliminar elemento'
      );

    }


    mostrarToast(
      resultado.mensaje,
      'success'
    );


    cerrarModalEliminar();

    await cargarElementos();


  } catch (error) {

    console.error(error);

    mostrarToast(
      error.message,
      'error'
    );

  }

}


// ============================================================
// CATEGORÍAS
// ============================================================

async function cargarCategorias() {

  try {

    const response =
      await fetch(
        `${API_BASE_URL}/categorias`,
        {
          headers: {
            'Authorization': getToken(),
            'Content-Type': 'application/json'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        'Error al cargar categorías'
      );

    }


    const data =
      await response.json();


    categoriasCasa =
      data.categorias || [];


    llenarSelectCategorias();

    inicializarTablaCategorias(
      categoriasCasa
    );


  } catch (error) {

    console.error(error);

    mostrarToast(
      'Error al cargar categorías',
      'error'
    );

  }

}


// ============================================================
// TABLA CATEGORÍAS
// ============================================================

function inicializarTablaCategorias(datos) {

  const $tabla =
    $('#tablaCasaCategorias');


  if (
    $.fn.DataTable.isDataTable($tabla)
  ) {

    $tabla.DataTable().destroy();

  }


  $tabla.find('tbody').empty();


  tablaCategorias =
    $tabla.DataTable({

      responsive: true,

      data: datos,

      columns: [

        {
          data: 'id_categoria',
          className: 'text-center'
        },

        {
          data: 'nombre'
        },

        {
          data: 'orden',
          className: 'text-center'
        },

        {
          data: 'activo',
          className: 'text-center',
          render: renderActivo
        },

        {
          data: null,
          orderable: false,
          searchable: false,
          className: 'text-center',
          render: renderAccionesCategoria
        }

      ],

      order: [
        [2, 'asc']
      ],

      pageLength: 10,

      language:
        idiomaDataTable(),

      dom: 'rtip'

    });

}


function renderAccionesCategoria(data) {

  return `

    <div class="acciones-cell">

      <button
        type="button"
        class="btn-action btn-edit btn-editar-categoria"
        data-id="${data.id_categoria}"
        title="Editar"
      >
        <i class="fas fa-pencil-alt"></i>
      </button>

      <button
        type="button"
        class="btn-action btn-delete btn-eliminar-categoria"
        data-id="${data.id_categoria}"
        data-nombre="${data.nombre}"
        title="Eliminar"
      >
        <i class="fas fa-trash-alt"></i>
      </button>

    </div>

  `;

}


// ============================================================
// NUEVA CATEGORÍA
// ============================================================

function abrirNuevaCategoria() {

  categoriaActual = null;

  $('#formCasaCategoria')[0].reset();

  $('#categoria_id').val('');

  $('#categoria_orden').val(0);

  $('#categoria_activo').val('true');

  $('#modalCategoriaTitulo')
    .text('Nueva categoría');

  $('#modalCasaCategoria')
    .addClass('active');

  $('#categoria_nombre')
    .focus();

}


// ============================================================
// EDITAR CATEGORÍA
// ============================================================

function abrirEditarCategoria(id) {

  const categoria =
    categoriasCasa.find(
      item =>
        Number(item.id_categoria) ===
        Number(id)
    );


  if (!categoria) {

    mostrarToast(
      'Categoría no encontrada',
      'error'
    );

    return;

  }


  categoriaActual =
    categoria.id_categoria;


  $('#categoria_id')
    .val(categoria.id_categoria);

  $('#categoria_nombre')
    .val(categoria.nombre);

  $('#categoria_orden')
    .val(categoria.orden);

  $('#categoria_activo')
    .val(
      categoria.activo === true
        ? 'true'
        : 'false'
    );


  $('#modalCategoriaTitulo')
    .text(
      `Editar categoría (ID: ${categoria.id_categoria})`
    );


  $('#modalCasaCategoria')
    .addClass('active');

}


// ============================================================
// GUARDAR CATEGORÍA
// ============================================================

async function guardarCategoria() {

  const datos = {

    nombre:
      $('#categoria_nombre')
        .val()
        .trim(),

    orden:
      parseInt(
        $('#categoria_orden').val()
      ) || 0,

    activo:
      $('#categoria_activo')
        .val() === 'true'

  };


  if (!datos.nombre) {

    mostrarToast(
      'Ingrese el nombre de la categoría',
      'error'
    );

    return;

  }


  const esNueva =
    !categoriaActual;


  const url =
    esNueva
      ? `${API_BASE_URL}/categorias`
      : `${API_BASE_URL}/categorias/${categoriaActual}`;


  try {

    const response =
      await fetch(
        url,
        {
          method:
            esNueva
              ? 'POST'
              : 'PUT',

          headers: {
            'Authorization': getToken(),
            'Content-Type': 'application/json'
          },

          body:
            JSON.stringify(datos)
        }
      );


    const resultado =
      await response.json();


    if (!response.ok) {

      throw new Error(
        resultado.error ||
        'Error al guardar categoría'
      );

    }


    mostrarToast(
      resultado.mensaje,
      'success'
    );


    cerrarModalCategoria();

    await cargarCategorias();


  } catch (error) {

    console.error(error);

    mostrarToast(
      error.message,
      'error'
    );

  }

}


// ============================================================
// ELIMINAR CATEGORÍA
// ============================================================

function prepararEliminarCategoria(
  id,
  nombre
) {

  categoriaAEliminar = id;
  elementoAEliminar = null;


  $('#textoCasaEliminar')
    .html(
      `¿Desea eliminar la categoría <strong>${nombre}</strong>?`
    );


  $('#modalCasaEliminar')
    .addClass('active');

}


async function eliminarCategoria() {

  if (!categoriaAEliminar) return;


  try {

    const response =
      await fetch(
        `${API_BASE_URL}/categorias/${categoriaAEliminar}`,
        {
          method: 'DELETE',

          headers: {
            'Authorization': getToken(),
            'Content-Type': 'application/json'
          }
        }
      );


    const resultado =
      await response.json();


    if (!response.ok) {

      throw new Error(
        resultado.error ||
        'Error al eliminar categoría'
      );

    }


    mostrarToast(
      resultado.mensaje,
      'success'
    );


    cerrarModalEliminar();

    await cargarCategorias();


  } catch (error) {

    console.error(error);

    mostrarToast(
      error.message,
      'error'
    );

  }

}


// ============================================================
// OPCIONES INTERNAS
// ============================================================

async function cargarOpcionesInternas() {

  try {

    const response =
      await fetch(
        `${API_BASE_URL}/opciones`,
        {
          headers: {
            'Authorization': getToken(),
            'Content-Type': 'application/json'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        'Error al cargar aplicaciones'
      );

    }


    const data =
      await response.json();


    opcionesInternas =
      data.opciones || [];


    llenarSelectOpciones();


  } catch (error) {

    console.error(error);

    mostrarToast(
      'Error al cargar aplicaciones internas',
      'error'
    );

  }

}


// ============================================================
// SELECTS
// ============================================================

function llenarSelectOpciones() {

  const select =
    $('#casa_id_opcion');


  select.html(`

    <option value="">
      Seleccione una aplicación
    </option>

  `);


  opcionesInternas.forEach(
    opcion => {

      select.append(`

        <option value="${opcion.id_opcion}">
          ${opcion.nombre}
          (${opcion.codigo})
        </option>

      `);

    }
  );

}


function llenarSelectCategorias() {

  const select =
    $('#casa_id_categoria');


  select.html(`

    <option value="">
      Seleccione una categoría
    </option>

  `);


  categoriasCasa.forEach(
    categoria => {

      if (
        categoria.activo === true
      ) {

        select.append(`

          <option value="${categoria.id_categoria}">
            ${categoria.nombre}
          </option>

        `);

      }

    }
  );

}


// ============================================================
// CAMPOS DINÁMICOS
// ============================================================

function actualizarCamposDestino() {

  const tipo =
    $('#casa_tipo_destino').val();


  $('#grupoDestinoInterno')
    .hide();

  $('#grupoDestinoExterno')
    .hide();

  $('#grupoDestinoCategoria')
    .hide();


  if (tipo === 'interno') {

    $('#grupoDestinoInterno')
      .show();

  }


  if (tipo === 'externo') {

    $('#grupoDestinoExterno')
      .show();

  }


  if (tipo === 'categoria') {

    $('#grupoDestinoCategoria')
      .show();

  }

}


// ============================================================
// COLOR
// ============================================================

function sincronizarPickerDesdeTexto() {

  const color =
    $('#casa_color')
      .val()
      .trim();


  if (
    /^#[0-9A-Fa-f]{6}$/.test(color)
  ) {

    $('#casa_color_picker')
      .val(color);

  }


  actualizarPreviewColor();

}


function sincronizarTextoDesdePicker() {

  const color =
    $('#casa_color_picker')
      .val();


  $('#casa_color')
    .val(
      color.toUpperCase()
    );


  actualizarPreviewColor();

}


function actualizarPreviewColor() {

  const color =
    $('#casa_color')
      .val();


  if (
    /^#[0-9A-Fa-f]{6}$/.test(color)
  ) {

    $('#casa_color_preview')
      .css(
        'background-color',
        color
      );

  }

}


// ============================================================
// TABS
// ============================================================

function cambiarTab(tab) {

  $('.mnto-casa-tab')
    .removeClass('active');

  $('.mnto-casa-panel')
    .removeClass('active');


  if (tab === 'categorias') {

    $('#tabCategorias')
      .addClass('active');

    $('#panelCategorias')
      .addClass('active');

  } else {

    $('#tabElementos')
      .addClass('active');

    $('#panelElementos')
      .addClass('active');

  }

}


// ============================================================
// CERRAR MODALES
// ============================================================

function cerrarModalElemento() {

  $('#modalCasaElemento')
    .removeClass('active');

  elementoActual = null;

}


function cerrarModalCategoria() {

  $('#modalCasaCategoria')
    .removeClass('active');

  categoriaActual = null;

}


function cerrarModalEliminar() {

  $('#modalCasaEliminar')
    .removeClass('active');

  elementoAEliminar = null;
  categoriaAEliminar = null;

}


// ============================================================
// EVENTOS
// ============================================================

function bindEvents() {

  $('.mnto-casa-tab')
    .off('click')
    .on('click', function () {

      cambiarTab(
        $(this).data('tab')
      );

    });


  $('#btnAgregarElementoCasa')
    .off('click')
    .on(
      'click',
      abrirNuevoElemento
    );


  $('#btnAgregarCategoriaCasa')
    .off('click')
    .on(
      'click',
      abrirNuevaCategoria
    );


  $('#casa_tipo_destino')
    .off('change')
    .on(
      'change',
      actualizarCamposDestino
    );


  $('#casa_color_picker')
    .off('input change')
    .on(
      'input change',
      sincronizarTextoDesdePicker
    );


  $('#casa_color')
    .off('input change')
    .on(
      'input change',
      sincronizarPickerDesdeTexto
    );


  $('#formCasaElemento')
    .off('submit')
    .on('submit', function (e) {

      e.preventDefault();

      guardarElemento();

    });


  $('#formCasaCategoria')
    .off('submit')
    .on('submit', function (e) {

      e.preventDefault();

      guardarCategoria();

    });


  $(document)
    .off(
      'click',
      '.btn-editar-elemento'
    )
    .on(
      'click',
      '.btn-editar-elemento',
      function () {

        abrirEditarElemento(
          $(this).data('id')
        );

      }
    );


  $(document)
    .off(
      'click',
      '.btn-eliminar-elemento'
    )
    .on(
      'click',
      '.btn-eliminar-elemento',
      function () {

        prepararEliminarElemento(
          $(this).data('id'),
          $(this).data('nombre')
        );

      }
    );


  $(document)
    .off(
      'click',
      '.btn-editar-categoria'
    )
    .on(
      'click',
      '.btn-editar-categoria',
      function () {

        abrirEditarCategoria(
          $(this).data('id')
        );

      }
    );


  $(document)
    .off(
      'click',
      '.btn-eliminar-categoria'
    )
    .on(
      'click',
      '.btn-eliminar-categoria',
      function () {

        prepararEliminarCategoria(
          $(this).data('id'),
          $(this).data('nombre')
        );

      }
    );


  $('#btnConfirmarCasaEliminar')
    .off('click')
    .on('click', function () {

      if (elementoAEliminar) {

        eliminarElemento();

        return;

      }


      if (categoriaAEliminar) {

        eliminarCategoria();

      }

    });


  $('#btnCerrarElemento, #btnCancelarElemento')
    .off('click')
    .on(
      'click',
      cerrarModalElemento
    );


  $('#btnCerrarCategoria, #btnCancelarCategoria')
    .off('click')
    .on(
      'click',
      cerrarModalCategoria
    );


  $('#btnCancelarCasaEliminar')
    .off('click')
    .on(
      'click',
      cerrarModalEliminar
    );

}


// ============================================================
// IDIOMA DATATABLE
// ============================================================

function idiomaDataTable() {

  return {

    sProcessing: 'Procesando...',

    sLengthMenu:
      'Mostrar _MENU_ registros',

    sZeroRecords:
      'No se encontraron resultados',

    sEmptyTable:
      'Ningún dato disponible',

    sInfo:
      'Mostrando _START_ a _END_ de _TOTAL_ registros',

    sInfoEmpty:
      'Mostrando 0 a 0 de 0 registros',

    sInfoFiltered:
      '(filtrado de _MAX_ registros)',

    sSearch:
      'Buscar:',

    sLoadingRecords:
      'Cargando...',

    oPaginate: {

      sFirst:
        'Primero',

      sLast:
        'Último',

      sNext:
        'Siguiente',

      sPrevious:
        'Anterior'

    }

  };

}